<template>
    <div class="IncomeExpress">
        <slider-question v-bind="{
            title: 'What is your total annual income before tax?',
            min: 0,
            type: 'money',
            format: 'thousands',
            max: 120000,
            tick: 20000,
            step: 1000,
            value: this.$store.state.income,
            customVal: this.$store.state.customIncome,
            name: 'income',
            customName: 'customIncome',
            next: 'results'
        }">
        </slider-question>

        <slot />
    </div>
</template>

<script>
    import SliderQuestion from '../components/questions/SliderQuestion.vue';

    export default {
        name: 'ExpressIncome',
        components: {
            SliderQuestion
        },
        created: function() {
            this.$store.commit('update', { name: 'calculator', value: 'express' });
            this.$store.commit('update', { name: 'product', value: 'income' });
        }
    }
</script>

<style lang="scss" scoped>
    .IncomeExpress {
        text-align: center;
    }
</style>
